import * as React from "react";

const ArrowFourIconSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="33">
    <path
      fill="#D3E205"
      d="M2.863 32 0 29.16 13.271 16-.001 2.84 2.863 0 19 16z"
    ></path>
  </svg>
);

export default ArrowFourIconSVG;


